export default __webpack_public_path__ + "static/media/Karen_Scott_AHV_In_Moms_We_Trust.663afd07.jpg";